import React from "react"
import * as Reach from "@reach/accordion"
import "@reach/accordion/styles.css"

import Item from "./_Item"

function Accordion({ category }) {
  if (category.faqItems && category.faqItems[0])
    return (
      <section
        id="faq"
        className="py-24 wrapper default-grid gap-y-10 md:gap-y-14"
      >
        {category.faqTitle && (
          <h2 className="space-y-4 text-center md:col-start-3 md:col-span-8 text-darkNavy h3 col-span-full">
            {category.faqTitle}
          </h2>
        )}
        <div className="md:col-start-2 md:col-span-10 lg:col-start-3 lg:col-span-8 col-span-full">
          <Reach.Accordion
            as="ul"
            className="border-t border-opacity-50 divide-y border-mineralGray divide-mineralGray divide-opacity-50"
            collapsible={true}
            multiple={true}
          >
            {category.faqItems?.map((item, i) => (
              <Item {...item} key={`faqItems--${i}`} />
            ))}
          </Reach.Accordion>
        </div>
      </section>
    )
  else return null
}

export default Accordion
